import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { IoDownloadOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeeType } from "../redux/slices/feeMgtSlice";
import { memberPaymentUpload } from "../services/memberUploadService";
import { setloadTost } from "../redux/slices/toastSlice";

const PaymentUpload = ({ showColorStrip = true }) => {
  const dispatch = useDispatch();
  const feeTypeData = useSelector((state) => state?.feeMgt?.feeType);

  useEffect(() => {
    dispatch(fetchFeeType());
  }, [dispatch]);

  const initialValues = {
    feeType: "",
    file: '',
  };

  const handleSubmit = async (values) => {
    const payload = {
      FileUpload : values?.file
    }
    const response = await memberPaymentUpload({feeType: values?.feeType, payload});
    if (
      response?.isSuccess === true ||
      response?.payload?.isSuccess === true
    ) {
      dispatch(
        setloadTost({
          title: "Success",
          description: `Uploaded successfully`,
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top",
        })
      );
    } else {
      console.log('errors',)
      dispatch(
        setloadTost({
          title: "Error",
          description:
            response?.payload?.errors?.map((errors) => errors) ||  response?.errors?.map((errors) => errors) ||
            response?.payload?.error?.description ||  response?.error?.description ||
            "Failed to upload",
          status: "warning",
          duration: 5000,
          isClosable: true,
          position: "top",
        })
      );
    }

  };

  return (
    <>
      <Box display="inline-block">
        <Flex
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"20px"}
          mt={5}
          mb={2}
        >
          <Text fontSize={"18px"} fontWeight={"700"} color={"#D11A2A"}>
            Payment Upload
          </Text>
          <Flex alignItems={"center"} gap={3}>
            <Flex
              as="button"
              align="center"
              gap="5px"
              cursor="pointer"
              color="#D11A2A"
              fontSize="14px"
              fontWeight="600"
              lineHeight="16px"
            >
              <IoDownloadOutline />
              <Text>DOWNLOAD TEMPLATE HERE</Text>
            </Flex>
          </Flex>
        </Flex>
        <Box
          borderTop="10px solid transparent"
          borderRadius="8px"
          sx={{
            borderImage: showColorStrip
              ? "linear-gradient(to right, #E53E3E, #812773, #E53E3E)"
              : "none",
            borderImageSlice: showColorStrip ? 1 : 0,
          }}
        />
      </Box>
      <Box
        bgColor={"white"}
        height={["auto", "", "auto"]}
        px={"30px"}
        py={"20px"}
        mb={5}
      >
        <Text color={"#3A3541DE"} fontSize={"16px"} fontWeight={500}>
          Search Filters
        </Text>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(values) => handleSubmit(values)}
        >
          {({
            errors,
            touched,
            values,
            handleBlur,
            handleChange,
            setFieldValue,
          }) => (
            <Form>
              <Flex
                flexDirection={["column", "column", "row"]}
                alignItems={"flex-start"}
                gap={5}
                mt={4}
                width={"100%"}
              >
                <FormControl
                  isInvalid={errors.feeType && touched.feeType}
                  color="#121212"
                >
                  <FormLabel htmlFor="feeType" fontSize={"16px"}>
                    Fee Type
                  </FormLabel>
                  <Select
                    name="feeType"
                    placeholder="Select Fee Type"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    bg={"#F3F3F3"}
                    borderRadius={"0"}
                    focusBorderColor="#ffffff"
                    borderColor={"#FFFFFF"}
                    _hover={{ borderColor: "#FFFFFF" }}
                    _placeholder={{ color: "#B4B1B1" }}
                    value={values?.feeType}
                  >
                    {feeTypeData &&
                      feeTypeData.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                  </Select>
                  <FormErrorMessage>{errors.feeType}</FormErrorMessage>
                </FormControl>
                <FormControl>
                  <FormLabel fontSize={"16px"}>Choose File</FormLabel>
                  <Input
                    type="file"
                    name="file"
                    id="file"
                    accept=".xls, .xlsx"
                    onChange={(event) => {
                      setFieldValue("file", event.currentTarget.files[0]);
                    }}
                    bg={"#F3F3F3"}
                    borderRadius={"0"}
                    borderColor={"#FFFFFF"}
                    _hover={{ borderColor: "#FFFFFF" }}
                    _placeholder={{ color: "#B4B1B1" }}
                  />
                  {values?.file && (
                    <Text fontSize="13px" mt={2} color="gray.600">
                      Selected file: <strong>{values.file.name}</strong>
                    </Text>
                  )}
                </FormControl>
              </Flex>
              <Flex justifyContent={"flex-end"} alignItems={"center"}>
                <Button
                  mt={10}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  lineHeight={"16px"}
                  width={"118px"}
                  background={"#D11A2A"}
                  _hover={{ background: "#B81A25" }}
                  color={"#FFFFFF"}
                  type="submit"
                >
                  Upload File
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default PaymentUpload;
